import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {login, sendCode, verifyCode} from "../../Redux/Thunks";
import {Col, Row} from 'react-bootstrap';

import {service as StreamBankAuthService} from '../../Services/StreamBankAuthService';

import {ConfirmationDialog} from '../Common/ConfirmationDialog';
import {LoginComponent} from './LoginComponent';
import {VerificationComponent} from "./VerificationComponent";

export const LoginTimeoutPopup = (props) => {
    const loginState = useSelector(state => state.loginState);
    const {isVerifying, title, displayPhoneNumberForm, errors} = loginState;
    const dispatch = useDispatch();

    const sendCodeAction = () => dispatch(sendCode());
    const loginAction = () => dispatch(login(props.SuccessLogic));
    const verifyAction = () => dispatch(verifyCode(props.SuccessLogic));

    const getConfirmationMethod = () => {
        if (!isVerifying) {
            return {
                message: 'Confirm Login',
                action: loginAction,
            };
        }

        if (displayPhoneNumberForm) {
            return {
                message: 'Send Code',
                action: sendCodeAction,
            };
        }

        return {
            message: 'Submit',
            action: verifyAction,
        };
    };

    return <ConfirmationDialog
                Title={title || 'Login Timeout'}
                Body={
                    [
                        !isVerifying &&
                        <Row key={1}>
                            <Col xs={12}>
                                <p>Your login has timed out. Please enter your password to re-confirm your login.</p>
                            </Col>
                        </Row>,
                        (!isVerifying && errors.login) &&
                        <Row key={2}>
                            <Col xs={12}>
                                <p className="sb-login-popup-container-error-message">{errors.login}</p>
                            </Col>
                        </Row>,
                        <Row key={3}>
                            <Col xs={12}>
                                {
                                    !isVerifying ?
                                        <LoginComponent
                                            Login={loginAction}
                                            ForgotPassword={() => {}}
                                            HideButtons
                                        /> :
                                        <VerificationComponent
                                            OnSuccess={props.SuccessLogic}
                                            HideButtons
                                        />
                                }
                            </Col>
                        </Row>
                    ]
                }
                CancelButtonMessage={isVerifying ? 'Cancel' : 'Log Out'}
                ConfirmationButtonMessage={getConfirmationMethod().message}
                Display={props.Display}
                OnClose={() => {
                    StreamBankAuthService.Logout().then((x) => {
                        props.SuccessLogic?.();
                    });
                }}
                OnConfirm={() => getConfirmationMethod().action()}
                OnCustom={isVerifying && !displayPhoneNumberForm ? sendCodeAction : null}
                CustomButtonMessage={`Resend ${loginState.timer > 0 ? `(${loginState.timer}s)` : 'Code'}`}
                DisableCustomButton={loginState.timer > 0}
                className="sb-login-popup-container"
            />;
};

